import { useState } from "react";
import { fieldNames } from "../../components/KYCform/steps/step3/utils";

export const {
  CONFIRMATION_STATUS,
  LEGAL_FORM,
  LEGAL_KYC_FORM,
  DUAL_CITIZENSHIP_COUNTRY,
  ACTUAL_ADDRESS,
  LEGAL_ADDRESS,
  DUAL_CITIZENSHIP,
  CITY,
  COUNTRY,
  STREET,
  HOME_NUMBER,
  APARTMENT_NUMBER,
  CITY_VILLAGE,
  VILLAGE,
  PRIVATE_KYC_FORM,
  ACTIVITY_SUBJ,
  ACCOUNT_PURPOSES,
  MONTHLY_TURNOVER,
  CASH_TURNOVER_ID,
  INFO_COUNTERPARTIES,
  MONTHLY_INCOME,
  MONEY_SOURCES,
  HAS_USA_TAXES,
  HAS_GREEN_CARD,
  WEALTH_SOURCES,
  ASSETS,
  PEP,
  INFORMATION_ABOUT_RELATED_PEP,
  PLEASE_SPECIFY_WEALTH,
  PLEASE_SPECIFY_BANKS,
  OTHER_ASSETS,
  ACTIVITY_SUBJ_COMMENT,
  PLEASE_SPECIFY_INCOME_SOURCE,
  TIN,
  USA_TAXES_TYPE,
  USA_TAXES_TYPE_DESC,
  PRIVACY_AGREED,
  STREET_INFO,
  COUNTRY_INFO,
  ACCOUNT_NUMS,
  USA_TAXES_TYPE_FEDERAL,
  ORGANIZATION_LEGAL_FORM,
  COMPANY_NAME,
  IDENTIFICATION_NUMBER,
  EMAIL_ADDRESS,
  BUSINESS_ACTIVITY_DETAILS,
  OWNER_NAME,
  OWNER_LAST_NAME,
  OWNER_ID_NUMBER,
  BUSINESS_ACTIVITY_IN_GEORGIA,
  BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION,
  EXPORT_CONNECTIONS,
  REGISTRATION_COUNTRY,
  REGISTRATION_DATE,
  CATEGORY_OF_POLITICALLY_EXPOSED,
  WHERE_YOU_HAVE_BANK_ACCOUNTS,
  SELECTED_COUNTRY_FROM,
  SELECTED_COUNTRY_TO,
  CAPITAL_SOURCES,
  INCOME_FROM_OTHER_BUSINESS_ACTIVITIES,
  OTHER_BUSINESS_ACTIVITIES,
  CAPITAL_SOURCES_IN_BANK,
  CAPITAL_SOURCES_IN_BANK_OTHER,
  IS_ACTUAL_ADDRESS,
  JOB_POSITION,
  JOB,
  JOB_START_DATE,
  ORGANIZATION_NAME,
  ENTREPRENUER,
  IS_COMPANY_EXP_IMP,
  COMPANY_LEGAL_ADDRESS,
  COMPANY_ADDRESS,
  COMPANY_ACTUAL_ADDRESS_BOOLEAN,
  OWNERS_INFO,
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};
const initState = {
  [LEGAL_FORM]: "",
  [CONFIRMATION_STATUS]: false,
  [LEGAL_KYC_FORM]: "",
  [PRIVATE_KYC_FORM]: "",
  [ORGANIZATION_LEGAL_FORM]: "",
  [COMPANY_NAME]: "",
  [IDENTIFICATION_NUMBER]: "",
  [EMAIL_ADDRESS]: "",
  [BUSINESS_ACTIVITY_DETAILS]: "",
  [OWNER_NAME]: "",
  [OWNER_LAST_NAME]: "",
  [OWNER_ID_NUMBER]: "",
  [BUSINESS_ACTIVITY_IN_GEORGIA]: "",
  [BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION]: "",
  [EXPORT_CONNECTIONS]: "",
  [REGISTRATION_COUNTRY]: "",
  [REGISTRATION_DATE]: "",
  [CATEGORY_OF_POLITICALLY_EXPOSED]: "",
  [ACCOUNT_PURPOSES]: [],
  [SELECTED_COUNTRY_FROM]: [],
  [SELECTED_COUNTRY_TO]: [],
  [CAPITAL_SOURCES]: [],
  [INCOME_FROM_OTHER_BUSINESS_ACTIVITIES]: "",
  [OTHER_BUSINESS_ACTIVITIES]: "",
  [CAPITAL_SOURCES_IN_BANK]: [],
  [CAPITAL_SOURCES_IN_BANK_OTHER]: "",
  [LEGAL_ADDRESS]: {
    ...initAddress,
  },
  [IS_ACTUAL_ADDRESS]: false,
  [ACTUAL_ADDRESS]: {
    ...initAddress,
  },
  [COMPANY_LEGAL_ADDRESS]: {
    ...initAddress,
  },
  [COMPANY_ADDRESS]: {
    ...initAddress,
  },
  [DUAL_CITIZENSHIP_COUNTRY]: "",
  [DUAL_CITIZENSHIP]: "",
  [ACTIVITY_SUBJ]: "",
  [MONTHLY_TURNOVER]: "",
  [CASH_TURNOVER_ID]: "",
  [INFO_COUNTERPARTIES]: "",
  [MONTHLY_INCOME]: "",
  [MONEY_SOURCES]: [],
  [HAS_USA_TAXES]: "",
  [HAS_GREEN_CARD]: "",
  [WHERE_YOU_HAVE_BANK_ACCOUNTS]: [],
  [ASSETS]: [],
  [WEALTH_SOURCES]: [],
  [INFORMATION_ABOUT_RELATED_PEP]: "",
  [PEP]: "",
  [PLEASE_SPECIFY_WEALTH]: "",
  [PLEASE_SPECIFY_BANKS]: "",
  [OTHER_ASSETS]: "",
  [ACTIVITY_SUBJ_COMMENT]: "",
  [PLEASE_SPECIFY_INCOME_SOURCE]: "",
  [TIN]: "",
  [USA_TAXES_TYPE]: "",
  [USA_TAXES_TYPE_DESC]: "",
  [USA_TAXES_TYPE_FEDERAL]: "",
  [PRIVACY_AGREED]: false,
  [STREET_INFO]: "",
  [COUNTRY_INFO]: "",
  [ACCOUNT_NUMS]: "",
  [IS_COMPANY_EXP_IMP]: "",
  [JOB_START_DATE]: "",
  [JOB_POSITION]: "",
  [JOB]: "",
  [ORGANIZATION_NAME]: "",
  [ENTREPRENUER]: "",
  [COMPANY_ACTUAL_ADDRESS_BOOLEAN]: false,
  [OWNERS_INFO]: { 0: { name: "", idNumber: "" } },
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
